import './lib/runtime-compat';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource/inter/variable.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import 'material-symbols/outlined.css';
import './globals.css';
import './i18n';
import { applyDocumentMeta } from './lib/document-meta';

// Rewrite static index.html <title>/<meta> for CN deployments (IS_CN=true).
// index.html ships overseas defaults; this localizes them at runtime.
applyDocumentMeta();

createRoot(document.getElementById('root')!).render(<App />);
